import {
  get,
  post,
  put,
  del,

} from '../configApi'

export async function insertMarketCategory(body){
  return await post(`/market_category/manage/insert`, {
    title: body.name,
    image: body.logo
  })
}

export async function fetchMarketCategory(body) {
  return await get(`/market_category/list/admin`, {
    sort: body.sort,
    sortby: body.sortby,
    page: body.page,
    limit: body.limit,
    active: body.active
  })
}

export async function updateMarketCategory(body) {
  return await put(`/market_category/manage/update`, {
    id: body.id,
    title: body.name,
    image: body.logo,
    active: body.status,
    priority: body.priority,
    levelSub: body.levelSub,
    categories: body.categories
  })
}

export async function updateActiveMarketCategory(body) {
  return await put(`/market_category/manage/active`, {
    id: body.id,
    active: body.status
  })
}

// export async function loadCategory() {
//   return await get(`/category/list`)
// }
// export async function loadCategoryList(params) {
//   return await get(`/category/list/admin`, params)
// }
// export async function insertCategory(body) {
//   return await post(`/category/manage/insert`,body)
// }
// export async function updateCategory(body) {
//   return await put(`/category/manage/update`,body)
// }
// export async function updateActive(body) {
//   return await put(`/category/manage/active`,body)
// }
// export async function deleteCategory(body) {
//   return await del(`/category/manage/delete`, body)
// }
// export async function getCategoryListBin(body) {
//   return await get(`/category/list/adminbin`, body)
// }

